import React from 'react';

/**
 * Sidebar / stacked panel for publish toggles (active, featured, comments, etc.)
 * Keeps checkboxes away from the rich-text editor on all breakpoints.
 */
export default function PublishingOptionsPanel({ title = 'Publishing options', children, className = '' }) {
  return (
    <aside
      className={`rounded-lg border border-gray-200 bg-gray-50 p-4 shadow-sm lg:sticky lg:top-4 lg:self-start ${className}`}
    >
      <h2 className="text-sm font-semibold text-gray-900 mb-3 pb-2 border-b border-gray-200">{title}</h2>
      <div className="flex flex-col gap-3">{children}</div>
    </aside>
  );
}
